export default "__VITE_ASSET__C6wJvg0I__"